import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../../../services/auth/authentication.service';
import { Router } from '@angular/router';
import { TokenStorage } from '../../../../storages/token.storage';
import { NavbarInfoService } from '../../../home/services/navbar-info.service';
import { LoggingService } from '../../../../services/logging.service';

declare var $: any;

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.sass']
})
export class LoginFormComponent implements OnInit {

  username: string;
  password: string;

  @Output()
  authEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  clearMessageEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private router: Router, 
    private auhenticationService: AuthenticationService, 
    private token: TokenStorage, 
    private info: NavbarInfoService,
    private loggingService: LoggingService
  ) { }

  ngOnInit() {
    $('#navbar').hide();
  }

  login(): void {
    const _xid = this.loggingService.generateUUID();
    const qualName = 'App.Components.LoginFormComponent.login';
    
    try {
      this.loggingService.logStart(_xid, qualName, null, 'User login started');
      
      this.clearMessageEvent.emit(true);
      window.localStorage.clear();

      this.auhenticationService.attemptAuth(this.username, this.password).subscribe(
        data => {
          this.token.saveToken(data);
          this.getPerson();
          this.loggingService.logFinish(_xid, qualName, null, 'User logged in successfully');
        }, err => {
          this.username = '';
          this.password = '';
          this.authEvent.emit(err);
          this.loggingService.logError(_xid, qualName, err, null, 'Login failed');
        }
      );
    } catch (_error) {
      this.loggingService.logError(_xid, qualName, _error, null, 'Login method failed');
      throw _error;
    }
  }

  getPerson(): void {
    const _xid = this.loggingService.generateUUID();
    const qualName = 'App.Components.LoginFormComponent.getPerson';
    
    try {
      this.loggingService.logStart(_xid, qualName, null, 'Getting person info');
      
      this.info.get().subscribe(info => {
        if (info != null) {
          this.token.setRole(info);

          document.getElementById("userName").textContent = info["name"];

          this.router.navigate(['home']);
          this.loggingService.logFinish(_xid, qualName, null, 'Person info retrieved');
        } else {
          this.loggingService.logFinish(_xid, qualName, null, 'No person info');
        }
      }, err => {
        this.loggingService.logError(_xid, qualName, err, null, 'Failed to get person info');
      });
    } catch (_error) {
      this.loggingService.logError(_xid, qualName, _error, null, 'getPerson method failed');
      throw _error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/components/login-form/login-form.component.ts